import { render, staticRenderFns } from "./CopyStakeGamificationCenterTabsView.vue?vue&type=template&id=6083fa2c&scoped=true&lang=pug"
import script from "./CopyStakeGamificationCenterTabsView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeGamificationCenterTabsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083fa2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabsItems})
